import cls from './add-website-modal.module.scss';
import { useTranslation } from 'hooks';
import Button from 'shared/ui/button/button';
import { useState, FC } from 'react';
import { Modal } from 'shared/ui/modal/modal';
import { validateDomain } from 'shared/helpers/validateDomain';
import { InputField } from 'shared/ui/inputField/inputField';
import { useDebounce } from 'shared/hooks/useDebounce';
import { useAddDomainMutation } from 'store/api/userApiSlice';
import { snackbar } from 'shared/helpers/snackbar';

interface AddWebsiteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AddWebsiteModal: FC<AddWebsiteModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const [addDomain] = useAddDomainMutation();
  const [error, setError] = useState<boolean>(false);
  const [domain, setDomain] = useState<string>('');
  const debouncedValidation = useDebounce(() => {
    if (!domain) {
      setError(false);
      return;
    }
    if (!validateDomain(domain)) {
      setError(true);
    } else {
      setError(false);
    }
  }, 500);

  const onChangeHandler = (value: string) => {
    setDomain(value);
    debouncedValidation();
  };

  const handleAddWebsite = async () => {
    if (domain && validateDomain(domain)) {
      try {
        await addDomain(domain)
          .unwrap()
          .then(r => {
            if (r.errors) {
              snackbar(r.errors.domain[0] || 'Failed to add domain');
            } else {
              snackbar('Domain added successfully');
              onClose();
            }
          });
      } catch (err) {
        snackbar(
          (err as any).data?.errors?.domain?.[0] || 'Failed to add domain'
        );
      }
    } else {
      setError(true);
    }
  };
  return (
    <Modal className={cls.addWebsiteModal} isOpen={isOpen} onClose={onClose}>
      <div className={cls.modal}>
        <h2>{t('add_website')}</h2>
        <p className={cls.description}>{t('addWebsiteDescription')}</p>
        <div className={cls.inputGroup}>
          <InputField
            label={t('websiteDomain')}
            value={domain}
            onChange={e => onChangeHandler(e.target.value)}
            error={error}
            errorMessage={t('invalidDomain')}
            placeholder={t('enterDomain')}
            name='domain'
          />
        </div>
        <div className={cls.modalActions}>
          <Button theme='text' tone='default' onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button theme='filled' tone='default' onClick={handleAddWebsite}>
            {t('add_website')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
